import React, { useRef } from "react";
import { Button, SelectableOptionGroup, TextAreaGroup } from "../../../common";
import * as style from "../styles.module.scss";

const HealthAndDisability = ({
  handleSubmit,
  handleBack,
  state,
  errors,
  handleChange,
  options,
}) => {
  const fieldRefs = useRef({});
  const handleFormSubmit = (e) => {
    e.preventDefault();
    handleSubmit(fieldRefs);
  };

  return (
    <form
      className={`col-sm-12 col-lg-6 mt-2 mt-lg-4 mb-2 ${style.form}`}
      onSubmit={handleFormSubmit}
    >
      <div>
        <p className="mb-2">
          Do you have any health conditions or disabilities which could make it
          difficult for you to perform the essential functions of the type of
          roles you are applying for?
        </p>
        <p className="mb-2">
          If you answer yes, please let us know what they are and what, if any,
          reasonable adjustments you may need to ensure fair access to the
          interview, induction process (if relevant) or the role itself.
        </p>
        <p className="mb-2">
          While we will consider all requests, reasonable adjustments cannot
          always be guaranteed.
        </p>
        <div className="form-group">
          <SelectableOptionGroup
            selectedOption={state.healthAndDisability}
            handleOptionChange={(e) => {
              handleChange("healthAndDisability", e.target.value);
            }}
            options={options}
            name="healthAndDisability"
          />
        </div>

        <div
          className={`${
            state.healthAndDisability === "yes"
              ? "form-group mb-4 mt-1"
              : "mb-3"
          } ${style.smoothAppear} ${
            state.healthAndDisability === "yes"
              ? ` ${style.smoothAppear__show}`
              : ""
          }`}
          ref={(el) => {
            fieldRefs.current.healthAndDisabilityNote = el;
          }}
        >
          <label htmlFor="healthAndDisabilityNote">
            Please add details below*
          </label>
          <TextAreaGroup
            classes={"register_field"}
            inputName="healthAndDisabilityNote"
            value={state.healthAndDisabilityNote}
            onChange={(e) =>
              handleChange("healthAndDisabilityNote", e.target.value)
            }
            rows={5}
            validationMessageIsRed
            validationMessages={errors?.healthAndDisabilityNote}
          />
        </div>
      </div>

      <div className={`mt-lg-auto mb-lg-2 ${style.actions}`}>
        <Button
          classes="btn btn-outline-info text-dark mr-1"
          onClick={handleBack}
        >
          Back
        </Button>
        <Button classes="btn btn-primary btn-block">Next</Button>
      </div>
    </form>
  );
};

export default HealthAndDisability;
